import { useState } from 'react';

export function CountPad(props: { prompt: string; onSubmit: (n: number) => void }) {
  const [s, setS] = useState('');
  const n = s === '' ? null : Number(s);
  const tap = (d: string) => setS((v) => (v.length >= 2 ? v : v === '0' ? d : v + d));
  return (
    <div className="pad-wrap">
      <div className="pad-hint">{props.prompt}</div>
      <div className="pad-display" aria-live="off">{s === '' ? '–' : s}</div>
      <div className="pad" role="group" aria-label="Enter your count">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
          <button key={d} type="button" onClick={() => tap(d)}>
            {d}
          </button>
        ))}
        <button type="button" onClick={() => setS('')} aria-label="Clear">
          ⌫
        </button>
        <button type="button" onClick={() => tap('0')}>
          0
        </button>
        <button type="button" className="go" disabled={n === null} onClick={() => n !== null && props.onSubmit(n)} aria-label="Submit count">
          ✓
        </button>
      </div>
    </div>
  );
}
